import React from 'react'
import { StakingBackground } from '../common/StakingBackground'

export function RswETHBackground() {
  return <StakingBackground />
}
